import {Divider, Form, SelectPicker} from "rsuite";
import React, {useEffect, useState} from "react";

// TODO make a rest call to return what the server supports
const QUERY_FIELD_TYPES = ['experience'];
const OPERATION_TYPES = ['greaterThan', 'lessThan'];

const ExternalApiQueryForm = () => {
    const [queryFieldTypes, setQueryFieldTypes] = useState([]);
    const [operationTypes, setOperationTypes] = useState([]);

    // format data for drop down boxes so rsuite is happy
    useEffect(() => {
        setQueryFieldTypes(QUERY_FIELD_TYPES.map(ele => ({label: ele, value: ele})));
        setOperationTypes(OPERATION_TYPES.map(ele => ({label: ele, value: ele})));
    }, []);

    return (
        <>
            <p>This is an advanced query meant to test out other systems calling our external API</p>
            <Divider />
            <Form.Group>
                <Form.ControlLabel>Query Field</Form.ControlLabel>
                <Form.Control
                    name="queryField"
                    accepter={SelectPicker}
                    data={queryFieldTypes}
                />
            </Form.Group>
            <Form.Group>
                <Form.ControlLabel>Operation</Form.ControlLabel>
                <Form.Control
                    name="operation"
                    accepter={SelectPicker}
                    data={operationTypes}
                />
            </Form.Group>
            <Form.Group>
                <Form.ControlLabel>Value</Form.ControlLabel>
                <Form.Control
                    name="value"
                    style={{width: 300}}
                />
            </Form.Group>
            </>
    );
};

export default ExternalApiQueryForm;